
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 6h-5.59a1 1 0 01-.7-.29l-1.42-1.42a1 1 0 00-.7-.29H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2zm-7 7.5a.5.5 0 01-.5.5H10v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V14H5.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H8V9.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V12h2.5a.5.5 0 01.5.5v1z"}})])
          )
        }
      }
    